import React from 'react';
import { Outlet } from 'react-router-dom';

const TelemetryRoot = () => {
  return <Outlet />;
};

export default TelemetryRoot;
